import React from 'react'
import "@fontsource/ubuntu";
import { makeStyles } from '@material-ui/core';
import Abc from "../../assets/images/png/Abc.png"
import Hrc from "../../assets/images/png/Hrc.png"
const useStyles = makeStyles({
    img: {
        height: "2.5rem",
        marginRight: "26vw"
    },
    mainDiv: {
        padding: "1rem 2rem",
        display: "flex",
    }

})
const Header = () => {
    const classes = useStyles();
    return (
        <div className={classes.mainDiv}>
            <div className={classes.div}>
                <img src={Abc} alt="" className={classes.img} />
            </div>
            <div className={classes.div}>
                <img src={Hrc} alt="" className={classes.img} />
            </div>
        </div>
    )
}

export default Header
